import React from 'react';
import { MAP_DEFAULT_VAR, BaseMapItem } from 'types';
import { debugLog } from 'utilities/basemap-debug.util';

const isEnable = (item: any) => {
  // Category 1 basemaps are global and always available
  if (item.category === 1) {
    return true;
  }

  // If no geometry, enable by default
  if (!item.geometry) {
    return true;
  }

  // For state-specific basemaps (Category 2), check if current view
  // intersects with the basemap's coverage area
  const { loadedView, loadedMapModules } = window;

  if (!loadedView || !loadedMapModules) {
    return false;
  }

  const { Polygon } = loadedMapModules;

  if (!Polygon) {
    return false;
  }

  try {
    let polygon = new Polygon(item.geometry);
    const viewExtent = loadedView.extent.clone().expand(0.9);
    const polygonWkid = polygon.spatialReference?.wkid;

    // Fix mislabeled spatial reference: if polygon claims to be WGS84 (4326)
    // but coordinates are > 360, it's actually Web Mercator (102100)
    if (
      polygonWkid === 4326 &&
      polygon.extent &&
      (Math.abs(polygon.extent.xmin) > 360 ||
        Math.abs(polygon.extent.xmax) > 360)
    ) {
      debugLog(
        '[Basemap Enable] Correcting spatial reference for:',
        item.label
      );
      const correctedGeometry = {
        ...item.geometry,
        spatialReference: { wkid: 102100 }
      };
      polygon = new Polygon(correctedGeometry);
    }

    return viewExtent.intersects(polygon);
  } catch (error) {
    debugLog(
      '[Basemap Enable] Error checking geometry for:',
      item.label,
      error
    );
    return false;
  }
};

const BaseMapOptionItem: React.FC<Props> = ({
  item,
  baseMap,
  setBaseMapById
}) => {
  return (
    <div
      className={`base-map-switcher-item${
        !isEnable(item) ? ' is-disabled' : ''
      }`}
      onClick={() => isEnable(item) && setBaseMapById(item.id, item.theme)}
    >
      <div className="base-map-switcher-item-thrumbnail">
        <img src={item.thrumbnailUrl} alt="" />
      </div>
      <div className="base-map-switcher-item-label">
        <label>{item.label}</label>
      </div>
      {((baseMap && item.id === baseMap) ||
        (!baseMap && item.id === MAP_DEFAULT_VAR.BASEMAP)) && (
        <div className="base-map-switcher-item-marker" />
      )}
    </div>
  );
};

type Props = {
  item: BaseMapItem;
  baseMap: string;
  setBaseMapById: Function;
};

export default React.memo(BaseMapOptionItem);
